export default "__VITE_ASSET__BkOcsf7t__"